import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, filter, map, of, switchMap, tap } from 'rxjs';
import { StoreErrorHandler } from '../base/effects.base';
import { moneyAccountActions, moneyAccountApiActions } from './money-account.actions';
import { MoneyAccountInfrastructure } from './money-account.infrastructure';
import { moneyAccountFeature } from './money-account.reducers';

@Injectable({ providedIn: 'root' })
export class MoneyAccountEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly moneyAccountInfrastructure = inject(MoneyAccountInfrastructure);
  private readonly storeErrorHandler = inject(StoreErrorHandler);

  public loadAccount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(moneyAccountActions.loadAccount),
      concatLatestFrom(() => this.store.select(moneyAccountFeature.selectMoneyAccountState)),
      filter(([{ force }, { initiallyLoaded }]) => force || !initiallyLoaded),
      // eslint-disable-next-line @ngrx/no-dispatch-in-effects
      tap(() => this.store.dispatch(moneyAccountActions.setLoading({ loading: true }))),
      switchMap(() =>
        this.moneyAccountInfrastructure.getAccount().pipe(
          map((account) => moneyAccountApiActions.loadAccountSuccess({ account })),
          catchError((error) => of(moneyAccountApiActions.loadAccountFailure({ error }))),
        ),
      ),
      catchError((error) => of(moneyAccountApiActions.loadAccountFailure({ error }))),
    );
  });

  public handleBackendErrors$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(moneyAccountApiActions.loadAccountFailure),
        tap(({ error }) => this.storeErrorHandler.handleBackendError(error)),
      );
    },
    { dispatch: false },
  );
}
